module.exports = __webpack_public_path__ + "static/media/muyou61.320e6842.png";